<template>
  <div class="app-main-content">
    <div class="app-main-inner-tab" style="flex-grow:1;display:flex;flex-direction:column">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('Insurance.LiabilityInsuranceHomepage')" name="liabilityInsurance">
          <liability-home-page @toInquiry="toInquiry" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('Insurance.PolicyManagement')" name="policyManagement">
          <policy-grid ref="policyGrid" :insurance-type="2" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import PolicyGrid from '@/views/cargo/v0/Insurance/components/policyGrid'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import LiabilityHomePage from '@/views/cargo/v0/Insurance/components/liabilityHomePage'

export default {
  name: 'LiabilityInsurance',
  components: { LiabilityHomePage, PolicyGrid, searchItem },
  data() {
    return {
      loading: false,
      activeTabName: 'liabilityInsurance',
      insuranceAgents: InsuranceConstants.INSURANCE_AGENT
    }
  },
  methods: {
    toInquiry(agent) {
      this.activeTabName = 'policyManagement'
      setTimeout(() => {
        this.$refs.policyGrid.addInquiry(agent)
      }, 100)
    },
    handleTabClick(value) {
      if (this.activeTabName === 'policyManagement') {
        setTimeout(() => {
          this.$refs.policyGrid.fetchDataByPage()
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
</style>

